<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
        >添加</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="用户名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="角色" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag class="m-r-5" type="success" v-for="role in scope.row.roles"> {{role.name}} </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="180"
        class-name="small-padding fixed-width"
      >
        <template v-if="scope.row.id != 1" slot-scope="scope">
          <el-row>
            <el-button
              type="primary"
              size="mini"
              @click="handleUpdate(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="handleDel(scope.row.id)"
              >删除</el-button
            >
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules[dialogStatus]"
        :model="form"
        label-position="left"
        label-width="70px"
        style="margin-left: 50px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" style="width: 500px" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="text" v-model="form.password" style="width: 500px" />
        </el-form-item>
        <!-- <el-form-item label="角色" prop="roles">
          <el-checkbox :indeterminate="isIndeterminateRoles" v-model="checkAllRoles" @change="handleCheckAllRolesChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="form.roles" @change="handleCheckedRolesChange">
            <el-checkbox v-for="role in allRoles" :label="role.id" :key="role.id">{{role.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="权限" prop="permissions">
          <el-checkbox
            :indeterminate="isIndeterminatePermissions"
            v-model="checkAllPermissions"
            @change="handleCheckAllPermissionsChange"
          >
            全选
          </el-checkbox>
          <!-- <div style="margin: 15px 0"></div> -->
          <div class="colorStyle">管理员权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.admin"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">用户管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.user"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">课程管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.classLi"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">资讯管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.information"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">招聘管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.recruit"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">活动管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.activity"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">建站管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.establish"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">运营管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.operation"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">财务管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.finance"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>

          <div class="colorStyle">电竞管理权限</div>
          <el-checkbox-group
            v-model="form.permissions"
            @change="handleCheckedPermissionsChange"
          >
            <el-checkbox
              v-for="permission in permis.electronicSport"
              :label="permission.id"
              :key="permission.id"
            >
              {{ permission.display_name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      btnLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },

      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加",
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: "",
        username: "",
        password: "",
        roles: [],
        permissions: [],
      },
      rules: {
        create: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" },
          ],
          password: [
            { required: true, message: "密码不能为空", trigger: "change" },
          ],
        },
        update: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" },
          ],
        },
      },
      //角色复选框
      checkAllRoles: false,
      isIndeterminateRoles: false,
      allRoles: [],
      //权限复选框
      checkAllPermissions: false,
      isIndeterminatePermissions: false,
      allPermissions: [],
      //按钮提交loading
      btnLoading: false,
      permis: {
        admin: [], //管理员
        user: [], //用户
        classLi: [], //课程
        information: [], //资讯
        recruit: [], //招聘
        activity: [], //活动
        establish: [], //建站
        operation: [], //运营
        finance: [], //财务
        electronicSport: [], //电竞
      },
    };
  },
  created() {
    this.getList();
    this.getRoleAll();
    this.getPermissionAll();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/admin/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getRoleAll() {
      request({
        url: "/api/backend/role/all",
        method: "get",
        params: {},
      }).then((response) => {
        this.allRoles = response.data;
      });
    },
    getPermissionAll() {
      // let user = ["管理员列表", "用户列表"];
      let classLi = ["讲师列表", "课程列表", "评论列表"];
      let recruit = ["岗位类型", "公司列表", "职位管理", "简历列表"];
      let establish = [
        "服务条款",
        "免责声明",
        "用户隐私协议",
        "VIP权限介绍",
        "关于我们",
        "全豆设置",
        "审核状态",
      ];
      let operation = ["轮播图管理", "活动弹窗", "优惠券列表", "意见反馈"];
      let finance = ["财务流水", "充值流水"];
      let electronicSport = [
        "学校管理",
        "学生管理",
        "电竞教师管理",
        "技能课程管理",
        "课程排班列表",
      ];
      request({
        url: "/api/backend/permission/all",
        method: "get",
        params: {},
      }).then((response) => {
        this.allPermissions = response.data;
        response.data.forEach((item, index) => {
          if (item.display_name == "管理员列表") this.permis.admin.push(item);
          if (item.display_name == "用户列表") this.permis.user.push(item);
          if (item.display_name == "资讯列表")
            this.permis.information.push(item);
          if (item.display_name == "活动列表") this.permis.activity.push(item);

          let classLiids = classLi.findIndex(
            (value) => value == item.display_name
          );
          if (classLiids != -1) this.permis.classLi.push(item);
          let recruitids = recruit.findIndex(
            (value) => value == item.display_name
          );
          if (recruitids != -1) this.permis.recruit.push(item);
          let establishids = establish.findIndex(
            (value) => value == item.display_name
          );
          if (establishids != -1) this.permis.establish.push(item);
          let operationids = operation.findIndex(
            (value) => value == item.display_name
          );
          if (operationids != -1) this.permis.operation.push(item);
          let financeids = finance.findIndex(
            (value) => value == item.display_name
          );
          if (financeids != -1) this.permis.finance.push(item);
          let ids = electronicSport.findIndex(
            (value) => value == item.display_name
          );
          if (ids != -1) this.permis.electronicSport.push(item);
        });
        this.$forceUpdate(); //强制更新
        console.log(this.permis);
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      (this.form = {
        id: "",
        username: "",
        password: "",
        roles: [],
        permissions: [],
      }),
        (this.btnLoading = false);
      this.checkAllRoles = false;
      this.isIndeterminateRoles = false;
      this.checkAllPermissions = false;
      this.isIndeterminatePermissions = false;
    },

    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      let form = Object.assign({}, row); // copy obj
      let roles = [];
      let permissions = [];
      for (let i = 0; i < form.roles.length; i++) {
        roles.push(form.roles[i].id);
      }
      for (let i = 0; i < form.permissions.length; i++) {
        permissions.push(form.permissions[i].id);
      }
      this.handleCheckedRolesChange(form.roles);
      this.handleCheckedPermissionsChange(form.permissions);
      form.permissions = permissions;
      form.roles = roles;
      this.form = form;
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/admin/save",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/admin/del",
            method: "get",
            params: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleCheckAllRolesChange(val) {
      let checkedRoles = [];
      if (val) {
        for (let i = 0; i < this.allRoles.length; i++) {
          checkedRoles.push(this.allRoles[i].id);
        }
      }
      this.form.roles = checkedRoles;
      this.isIndeterminateRoles = false;
    },
    handleCheckedRolesChange(value) {
      let checkedCount = value.length;
      this.checkAllRoles = checkedCount === this.allRoles.length;
      this.isIndeterminateRoles =
        checkedCount > 0 && checkedCount < this.allRoles.length;
    },
    handleCheckAllPermissionsChange(val) {
      let checkedPermissions = [];
      if (val) {
        for (let i = 0; i < this.allPermissions.length; i++) {
          checkedPermissions.push(this.allPermissions[i].id);
        }
      }
      this.form.permissions = checkedPermissions;
      this.isIndeterminatePermissions = false;
    },
    handleCheckedPermissionsChange(value) {
      let checkedCount = value.length;
      this.checkAllPermissions = checkedCount === this.allPermissions.length;
      this.isIndeterminatePermissions =
        checkedCount > 0 && checkedCount < this.allPermissions.length;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.colorStyle {
  font-weight: bold;
}
</style>
